import { green } from "@mui/material/colors";
import StatusChip from "@entrilia/shared/components/StatusChip";
import { makeModeAwareAccent } from "@entrilia/shared/utilities/colorHelper";

const BetaLabel = () => <StatusChip label="Beta" color={(t) => makeModeAwareAccent(t, green)} height="smaller" />;

export default BetaLabel;
